import script from "./ChannelData.vue?vue&type=script&lang=ts&setup=true&name=memberList"
export * from "./ChannelData.vue?vue&type=script&lang=ts&setup=true&name=memberList"

import "./ChannelData.vue?vue&type=style&index=0&id=aaa5b8d8&lang=stylus&scoped=true"

import exportComponent from "/www/wwwroot/home/v-admin/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aaa5b8d8"]])

export default __exports__